import "./client.types";

import { UserType } from "@elation/api-client/src/stitch-web/models/userType";
import { IS_CHROME_EXTENSION, IS_IN_IFRAME, SERVICE_URL } from "@src/env";
import { ClientFetchOption } from "better-auth";
import {
  genericOAuthClient,
  inferAdditionalFields,
  organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient, SuccessContext } from "better-auth/react";
import { BEARER_TOKEN_KEY } from "./client.constants";

const chromeExtensionFetchOptions: ClientFetchOption = {
  onSuccess: (ctx: SuccessContext) => {
    const authToken = ctx.response.headers.get("set-auth-token");

    if (authToken) {
      localStorage.setItem(BEARER_TOKEN_KEY, authToken);
    }
  },
  auth: {
    type: "Bearer",
    token: () => {
      return localStorage.getItem(BEARER_TOKEN_KEY) || "";
    },
  },
};

const iframeFetchOptions: ClientFetchOption = {
  onSuccess: (ctx: SuccessContext) => {
    const authToken = ctx.response.headers.get("set-auth-token");

    if (authToken) {
      localStorage.setItem(BEARER_TOKEN_KEY, authToken);
    }
  },
  auth: {
    type: "Bearer",
    token: () => localStorage.getItem(BEARER_TOKEN_KEY) || "",
  },
};

const defaultFetchOptions: ClientFetchOption = {
  credentials: "include" as const,
};

export const authClient = createAuthClient({
  baseURL: IS_CHROME_EXTENSION
    ? SERVICE_URL
    : `${window.location.origin}/api/auth`,
  fetchOptions: IS_CHROME_EXTENSION
    ? chromeExtensionFetchOptions
    : IS_IN_IFRAME
      ? iframeFetchOptions
      : defaultFetchOptions,
  plugins: [
    genericOAuthClient(),
    organizationClient(),
    inferAdditionalFields({
      user: {
        type: {
          type: Object.values(UserType),
          required: true,
        },
      },
    }),
  ],
});

export type Session = typeof authClient.$Infer.Session;
